import { TIME_ZONES } from "./TIME_ZONES";

export const BROWSER_TIME_ZONE_NAME = TIME_ZONES.find(
  (tz) => tz.name === Intl.DateTimeFormat().resolvedOptions().timeZone,
)?.name;
